import DonutWithBite from 'components/icons/donut-with-bite';
import TimsCup from 'components/icons/tims-cup';

export const UnauthenticatedEmptyStateImage = TimsCup;
export const ErrorEmptyStateImage = DonutWithBite;
